var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSandClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.969,
    height: 59.222,
    viewBox: "0 0 41.969 59.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:url(#c);}.d{fill:url(#d);}.e{fill:url(#e);}.f{fill:url(#f);}.g{fill:url(#g);}.h{fill:url(#h);}.i{fill:url(#i);}.j{fill:url(#j);}.k{fill:url(#k);}.l{fill:url(#l);}.m{fill:url(#m);}.n{fill:url(#n);}.o{fill:url(#o);}.p{fill:url(#p);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.768,
    y1: 0.5,
    x2: 1.069,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3c3c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: 0.412,
    x2: 0.5,
    y2: 1.323,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    y1: 0.214,
    x2: 0.5,
    y2: 1.451,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.526,
    y1: 0.159,
    x2: 0.427,
    y2: -0.383,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3c3c3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#bdbcbc",
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#a39f9d",
    stopOpacity: 0.306
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#918b86",
    stopOpacity: 0.553
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#867e79",
    stopOpacity: 0.788
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#827a74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.525,
    y1: 0.475,
    x2: -0.177,
    y2: -0.277,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.443,
    y1: 0.5,
    x2: 0.851,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#acfcd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53d6be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.511,
    y1: 0.464,
    x2: -0.039,
    y2: 0.096,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d6be",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#51b4a7",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    stopColor: "#508d8e",
    stopOpacity: 0.576
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#4e767f",
    stopOpacity: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e6d79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -5.804,
    y1: -6.012,
    x2: -4.808,
    y2: -6.012,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d6be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#acfcd9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 13.103,
    y1: 4.536,
    x2: 14.099,
    y2: 4.536,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 1.606,
    y1: -0.664,
    x2: 2.603,
    y2: -0.664,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 6.563,
    y1: 2.089,
    x2: 7.559,
    y2: 2.089,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -0.994,
    y1: -1.393,
    x2: 0.002,
    y2: -1.393,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.5,
    y1: 0.283,
    x2: 0.5,
    y2: 1.134,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#827a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#605b55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0.5,
    y1: 0.283,
    x2: 0.5,
    y2: 1.134,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0.649,
    y1: 1.239,
    x2: -0.049,
    y2: 0.117,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#605b55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c4843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 0.228,
    y1: 0.361,
    x2: 0.864,
    y2: 0.686,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff9b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff465"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M50.521,126.351c0,.1,0,.194,0,.29v.038H11.242a22.564,22.564,0,0,1,8.939-17.907l6.045-4.624a.087.087,0,0,0,.014-.01,1.617,1.617,0,0,0,0-2.459.128.128,0,0,0-.014-.012l-6.045-4.624a22.616,22.616,0,0,1-8.841-15.836h0s0-.01,0-.014c-.009-.091-.017-.183-.024-.274-.013-.159-.025-.318-.035-.478s-.019-.35-.025-.525c0-.086-.006-.173-.008-.259l0-.2c0-.108,0-.216,0-.324H50.523a22.563,22.563,0,0,1-8.939,17.907l-6.045,4.624-.014.012a1.618,1.618,0,0,0,0,2.46l.014.01,6.045,4.624q.529.4,1.03.836.25.215.492.435c.164.148.324.3.483.451l.234.23a22.875,22.875,0,0,1,2.562,3.022c.109.155.217.309.323.467.122.182.243.367.359.552.057.091.115.182.17.274q.164.267.319.539c.053.092.105.186.157.279q.468.843.86,1.72c.044.1.087.2.129.293s.084.2.125.3c.028.068.057.137.084.206a22.056,22.056,0,0,1,.758,2.213c.03.1.059.206.086.308.023.084.046.168.066.253a21.819,21.819,0,0,1,.459,2.265q.045.3.082.6c.027.227.052.455.071.683.009.091.015.182.023.272,0,.045.006.089.009.134.008.092.013.185.018.277.016.253.026.5.033.759,0,.073,0,.146,0,.218Zm0,0",
    transform: "translate(-9.941 -69.983)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51.439,101.679l.014-.011,5.383-4.624A23.6,23.6,0,0,0,64.8,79.137H29.812a23.6,23.6,0,0,0,7.962,17.906l5.384,4.624.013.011a7.488,7.488,0,0,0,4.134,1.728,7.492,7.492,0,0,0,4.134-1.728Zm0,0",
    transform: "translate(-26.364 -69.983)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M64.841,308.42H29.868a23.557,23.557,0,0,1,7.956-17.409l5.382-4.624.014-.01a8.657,8.657,0,0,1,2.672-1.479q.158-.052.32-.094c.092-.024.186-.047.281-.065l.038-.008c.035-.006.069-.013.1-.018s.082-.014.122-.019l.025,0c.047-.006.094-.013.141-.017s.079-.009.119-.012l.091-.007c.074,0,.147-.006.221-.006s.147,0,.221.006l.091.007c.04,0,.08.006.12.012s.094.01.141.017l.026,0c.04,0,.081.012.121.019l.142.026c.095.019.188.041.281.065q.162.041.32.094a8.643,8.643,0,0,1,2.671,1.479l.014.01,5.384,4.624a23.308,23.308,0,0,1,7.746,14.639,24.369,24.369,0,0,1,.21,2.769Zm0,0",
    transform: "translate(-26.413 -251.723)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M35.528,101.679l.014-.011,6.045-4.624a22.559,22.559,0,0,0,8.939-17.906H11.246c0,.695.034,1.385.1,2.071l.4.616,38.778,44.818a22.56,22.56,0,0,0-8.939-17.868l-6.045-4.624-.015-.011a1.618,1.618,0,0,1,0-2.459Zm0,0",
    transform: "translate(-9.945 -69.983)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M136.431,89.9v1.376a22.977,22.977,0,0,1-5.338,5.767l-6.045,4.624a.128.128,0,0,0-.014.012,1.617,1.617,0,0,0,0,2.459.112.112,0,0,0,.014.01l4.982,3.811h-5.788l-2.773-2.772-4.857-5.615,1.146-7.478-4.682-4.758a1.073,1.073,0,0,1-.451-1.54l4.182-6.661h8.862Zm0,0",
    transform: "translate(-99.451 -69.98)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M81.915,228.489a11.827,11.827,0,0,0-4.592-9.522l-6.161-4.5a9.216,9.216,0,0,1-3.553-7.455,4.895,4.895,0,0,1,1.614-3.463l5.9-4.624a20.269,20.269,0,0,0,1.754-2.021.849.849,0,0,0-.371-1.311,36.849,36.849,0,0,0-19.018,0,.849.849,0,0,0-.371,1.311,20.329,20.329,0,0,0,1.753,2.021l5.9,4.624a4.895,4.895,0,0,1,1.614,3.463,9.216,9.216,0,0,1-3.554,7.455l-6.16,4.5a11.825,11.825,0,0,0-4.592,9.522c0,.023,0,.047,0,.07H81.915v-.07Zm0,0",
    transform: "translate(-46.058 -171.863)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M152.779,206.564a4.987,4.987,0,0,1,1.589-3.011l5.9-4.624a20.333,20.333,0,0,0,1.754-2.021.849.849,0,0,0-.371-1.311,36.871,36.871,0,0,0-12.215-1.147l-1.074,7.01Zm0,0",
    transform: "translate(-131.202 -171.87)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M222.237,349.607a.466.466,0,1,1-.466-.466A.466.466,0,0,1,222.237,349.607Zm0,0",
    transform: "translate(-195.707 -308.756)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M139.921,317.643a.466.466,0,1,1-.466-.467A.466.466,0,0,1,139.921,317.643Zm0,0",
    transform: "translate(-122.912 -280.489)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M193.449,316.613a.738.738,0,1,1-.738-.738A.738.738,0,0,1,193.449,316.613Zm0,0",
    transform: "translate(-169.767 -279.338)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M142.234,333.93a.739.739,0,1,1-.739-.739A.739.739,0,0,1,142.234,333.93Zm0,0",
    transform: "translate(-124.476 -294.651)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M214.558,318.144a1.136,1.136,0,1,1-1.136-1.136A1.136,1.136,0,0,1,214.558,318.144Zm0,0",
    transform: "translate(-187.731 -280.34)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M40.318,476.865H1.651A1.651,1.651,0,0,1,0,475.214V473.92a1.651,1.651,0,0,1,1.651-1.651H40.318a1.651,1.651,0,0,1,1.651,1.651v1.294A1.651,1.651,0,0,1,40.318,476.865Zm0,0",
    transform: "translate(0 -417.643)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M40.318,64.545H1.651A1.651,1.651,0,0,1,0,62.894V61.6a1.651,1.651,0,0,1,1.651-1.651H40.318A1.651,1.651,0,0,1,41.969,61.6v1.294A1.651,1.651,0,0,1,40.318,64.545Zm0,0",
    transform: "translate(0 -53.015)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M183.293,64.545h7.392l-4.6-4.6h-2.8Zm0,0",
    transform: "translate(-162.092 -53.015)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M127.25,13.563H123.56a1.072,1.072,0,0,1-1.06-1.234l1.7-11.091a1.072,1.072,0,0,0-1.967-.732l-9.61,15.309a1.072,1.072,0,0,0,.908,1.641h3.691a1.072,1.072,0,0,1,1.06,1.234l-1.7,11.091a1.072,1.072,0,0,0,1.967.732l9.61-15.308a1.072,1.072,0,0,0-.908-1.642Zm0,0",
    transform: "translate(-99.45 0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClock);
export default __webpack_public_path__ + "static/media/sand-clock.b1103540e72589eb5f9f3ddbeb12def0.svg";
export { ForwardRef as ReactComponent };